import certificateOperationPrint from '@/api/certificate-operation-print'
import MainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'
import Year from '@/api/academic-year'
import ClassOperation from '@/api/class-operation'
import employee from '@/api/employee'
import Term from '@/api/term-semester'
import Subject from '@/api/subject-core'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  cert_type_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CERT_TYPE_ID(state, data) {
    state.cert_type_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        filter: {
          cert_type_id: context.state.cert_type_id
        }
      },
      attrubutes
    )
    return certificateOperationPrint.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return certificateOperationPrint.store(data)
  },
  getCertificateType(context, attributes = {}) {
    return certificateOperationPrint.certificateType(attributes)
  },
  getMainProgram(context, attributes = {}) {
    return MainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getClasses(context, attributes = {}) {
    return ClassOperation.get({
      params: {
        page: -1,
        fields: {
          academic_classes: 'class_id,class_name'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  getClass(context, attributes = {}) {
    return ClassOperation.get({
      params: Object.assign(
        {
          fields: {
            academic_classes: 'class_id,class_name'
          },
          filter: {
            required_thesis: true
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getPosition(context, attributes = {}) {
    return employee
      .employeePosition({
        header: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
  },
  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubject(context, attrubutes = {}) {
    return Subject.get({
      params: {
        page: -1,
        fields: {
          academic_subjects: 'subject_id,subject_name_foreign,subject_code'
        },

        attrubutes
      }
    })
  },
  searchStudent(context, attributes = {}) {
    return certificateOperationPrint.studentCertificate({ params: attributes })
  },
  printPdf(context, id) {
    return certificateOperationPrint.printPdf(id)
  },
  qrCodeScan(context, attributes = {}) {
    return certificateOperationPrint.qrCodeScan({ params: attributes })
  },
  barCodeScan(context, attributes = {}) {
    return certificateOperationPrint.barCodeScan({ params: attributes })
  },
  getEventMgt(context, attributes = {}) {
    return certificateOperationPrint.eventMgt(attributes)
  },
}
